if(!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    // Cart Drawer Redesign A/B Test
    static observedAttributes = ['js-redesign-layout'];

    constructor() {
      super();
      this.focusedElementBeforeOpen = null;
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name == 'js-redesign-layout') {
        this.refresh();
      }
    }

    open() {
      this.focusedElementBeforeOpen = document.activeElement;
      scrollLock.enabledBodyScrollLock();
      // request animation frame for smoother animation process
      requestAnimationFrame(() => {
        this.setAttribute('open', '');
        // if quick view is open close it
        if(document.querySelector("quick-add-modal[open]")) {
          document.querySelector("quick-add-modal[open]").removeAttribute("open")
        }
        // trap element focus
        trapFocus(this);
        const firstFocusableElement = getFocusableElements(this)[0];
        if (firstFocusableElement) {
          firstFocusableElement.focus();
        }
        this.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
      });
    }

    close() {
      scrollLock.disableBodyScrollLock();
      this.removeAttribute('style');
      this.removeAttribute('open');

      const handleAnimationEnd = () => {
        removeTrapFocus();
        if (this.focusedElementBeforeOpen) {
          this.focusedElementBeforeOpen.focus();
        }
        this.removeEventListener('animationend', handleAnimationEnd);
      };

      this.addEventListener('animationend', handleAnimationEnd);
      this.dispatchEvent(new CustomEvent('cart-drawer:closed', { bubbles: true }));
    }

    handleClick(event, shouldPreventDefault) {
      if(shouldPreventDefault) event.preventDefault();
      event.stopPropagation();
      this.close();
    }

    initButtons() {
      this.closeButtons = document.querySelectorAll('.js-cart-close');
      this.continueButton = this.querySelector('.js-continue-button');

      if(this.closeButtons) this.closeButtons.forEach((button) => button.addEventListener('click', (event) => this.handleClick(event, true)));
      if(this.continueButton) this.continueButton.addEventListener('click', (event) => this.handleClick(event, true));
    }

    updateButtons(itemsInCart) {
      const cartHeadButton = this.querySelector('.js-cart-head-button');
      const continueHolder = this.querySelector('.js-continue-holder');

      if(itemsInCart > 0) {
        this.checkoutButton = this.checkoutButtonTemplate.content.firstElementChild.cloneNode(true);
        if(this.checkoutButton) cartHeadButton.innerHTML = this.checkoutButton.outerHTML;
        if(continueHolder){
          this.continueButton = this.continueButtonTemplate.content.firstElementChild.cloneNode(true);
          if(this.continueButton) continueHolder.innerHTML = this.continueButton.outerHTML;
        }
      } else {
        this.continueButton = this.continueButtonTemplate.content.firstElementChild.cloneNode(true);
        if(this.continueButton){
          cartHeadButton.innerHTML = this.continueButton.outerHTML;
          if(continueHolder) continueHolder.innerHTML = "";
        }
      }

      this.initButtons();
    }

    processUrl() {
      const href = window.location.href.split('#')[1];
      // if we are not at #cart, disregard and move on.
      if(!href?.includes('cart')) return;
      const headerTrigger = document.querySelector('.header__icons .js-cart-trigger');
      // if we cannot find the cart trigger in the header, move on.
      if(!headerTrigger) return;
      // if can, make sure the cart drawer isn't already "open"
      if(this.getAttribute('open')){
        // console.log("Cart Drawer is already open.");
      } else {
        // console.log("Cart Drawer is not open.");
        headerTrigger.click();
      }

    }

    setupTriggers() {
      if(!this.openTriggers) return;

      this.openTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.open();
        });
      });
    }

    setElements(){
      this.openTriggers = document.querySelectorAll('.js-cart-trigger');
      this.section = this.closest(`section.shopify-section`);
      this.continueButtonTemplate = this.querySelector('#continue-button-template');
      this.checkoutButtonTemplate = this.querySelector('#checkout-button-template');
      this.inner = this.querySelector('.js-drawer-inner');
      this.cartAnnouncement = this.querySelector('cart-announcement');
      this.cartNote = this.querySelector('cart-note');
      this.cartGWPSelector = this.querySelector('cart-gwp-selector');
    }

    initialize() {
      this.setElements();
      this.initButtons();
      this.setupTriggers();
      this.setHeaderCount();
      this.processUrl();

      window.cartDrawer = this;
    }

    setHeaderCount(){
      const currentItems = parseInt(this.querySelector('.js-items-count').getAttribute('data-js-current-items'), 10);
      const headerBlob = document.querySelector('.js-header-cart-count');
      const bubble = document.querySelector('.cart-count-bubble');

      if(headerBlob) headerBlob.innerHTML = currentItems;

      if (bubble && +currentItems > 0) {
        bubble.classList.remove('hidden');
      } else if(bubble) {
        bubble.classList.add('hidden');
      }
    }

    refresh() {
      let section = 'cart-drawer';
      let fetchParam = section;

      // Cart Drawer Redesign A/B Test
      if (this.hasAttribute('js-redesign-layout')) {
        // Add the class with redesign styles
        this.classList.add('cart-drawer-redesign');
        // Fetch the redesign layout
        fetchParam = `${fetchParam}&redesign=true`;
      }

      fetch(`/?sections=${fetchParam}`)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          const content = response[section];
          const html = new DOMParser().parseFromString(content, 'text/html');
          const cartDrawerSection = html.querySelector(`#shopify-section-${section}`);

          if (cartDrawerSection) {
            const newDrawer = cartDrawerSection.querySelector('cart-drawer');
            if (newDrawer) {
              const fragment = document.createDocumentFragment();

              while (newDrawer.firstChild) {
                fragment.appendChild(newDrawer.firstChild);
              }

              while (this.firstChild) {
                this.removeChild(this.firstChild);
              }

              this.appendChild(fragment);

              this.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));

              this.initialize();

              this.dispatchEvent(new CustomEvent('cart-drawer:refreshed', {
                bubbles: true,
                detail: {
                  firstItem: this.querySelector('cart-item:first-of-type')
                }
              }));
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    connectedCallback() {
      this.initialize();
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}
